const { Array } = require('stdlib/Array')

const { consts } = require('./consts')

const { getDate } = require('./getDate')

/**
 * Visszaadja az összes hetet, amely a két dátum között van (zárt intervallum).
 * @param {string} start - Kezdő dátum.
 * @param {string} end - Vége dátum.
 * @returns {readonly string[]} A hetek.
 */
module.exports.getWeeksBetweenDates = function getWeeksBetweenDates (start, end) {
  const startDate = new Date(start)
  const endDate   = new Date(end)

  // Ez meghatározza, hogy hány hétnyi különbség van a két dátum között.
  const diff = Math.ceil((endDate.getTime() - startDate.getTime()) / consts.WEEK_IN_MS)

  if (diff < 0) {
    return []
  }

  if (diff === 0 || diff === 1) {
    return [ start ]
  }

  const weeks = Array.times(diff, (offset) => {
    const weekDate = startDate.getTime() + (offset * consts.WEEK_IN_MS)

    return getDate(weekDate)
  })

  // Simán elképzelhető, hogy a végeként megadott dátum
  // éppen egybeesett a hetenkénti eltolással.
  // Ekkor teljesen rendben van az előállított tömb,
  // tehát egyszerűen csak vissza kell adni.
  if (Array.getLast(weeks) === end) {
    return weeks
  }

  // Ellenkező esetben pedig a létrehozott tömbhöz
  // még hozzáfűzzük a végdátumot.
  return [
    ...weeks,
    end
  ]
}
